<template>
  <div class="status" :class="{
    'status-span-center':!(aggregated_status.reason && aggregated_status.reason !== '')
  }">
    <span class="status-span"
      :class="{
        'text-green-600':
          aggregated_status.status == 'Delivering',
        'text-red-600':
          aggregated_status.status == 'Not Delivering'
      }"
    >
      {{ aggregated_status.status }}
    </span>

    <span class="status-span" v-if="aggregated_status.reason !== ''">
      {{ aggregated_status.reason }}
    </span>
  </div>
</template>

<script>
export default {
  computed: {
    aggregated_status () {
      return this.params.data ? this.params.data.aggregated_status : {}
    }
  }
}
</script>

<style lang="scss" scoped>
.status {
  line-height: 20px;
  margin-top: 4px;
}

.status-span {
  display: block;
  height: 20px;
}

.status-span-center {
  line-height: inherit;
  margin-top: 0;

  span {
    height: inherit;
  }
}
</style>